import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';
import { UserProfile } from 'src/app/models/userprofile.model';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  envt = '';
  userName = '';
  userId = '';
  log = 'Log Out';

  constructor(private oauthService: OAuthService,
    private authService: AuthService) {
  }

  ngOnInit(): void {

    this.envt = environment.environment;

    const userProfile: UserProfile = jwt_decode(this.accessToken);
    this.userName = userProfile.family_name?.concat(', ')?.concat(userProfile.given_name);
    this.userId = userProfile.sub;
  }

  get accessToken() {
    return this.oauthService.getAccessToken();
  }

  onLogOut() {
    this.authService.logOut();
  }
}
